import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import roomApi from 'src/api/room'

export const fetchAllRoom = createAsyncThunk(
  'product/fetchAllRoom',
  async () => {
    const response = await roomApi.getAllRoom()
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  status: '',
  allRoom: [],
  loading: true,
  error: '',
}
const slice = createSlice({
  name: 'room',
  initialState,
  reducers: {
    addRoom(oldState, action) {
      let newRoom = action.payload
      oldState.allRoom = [ newRoom, ...oldState.allRoom]
    },
    updateRoom(oldState, action) {
      let newRoom = action.payload
      let newAllRoom=[...oldState.allRoom]
      .filter((each)=>each.id!==newRoom.id)

      oldState.allRoom = [newRoom, ...newAllRoom]
    },

    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },

  extraReducers: {
    [fetchAllRoom.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchAllRoom.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.allRoom = action.payload
      state.loading = false
    },
    [fetchAllRoom.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

/* Room disptach */

export const addOrEditRoom = (requestBody) => async (dispatch) => {
  const result = await roomApi.addOrEditRoom(requestBody)
  if(requestBody.id){
    dispatch(slice.actions.updateRoom(result))
  }else{
    dispatch(slice.actions.addRoom(result))
  }
}


export default slice
